module.exports = __webpack_public_path__ + "img/Austin.2a4e5a64.jpeg";